module.exports = __webpack_public_path__ + "img/f20801e82aa580aca447b03a49b8874b.png";